export default __webpack_public_path__ + "static/NST-01506c579391293032cba65cd203ea24.png";